module.exports = __webpack_public_path__ + "img/logo.185bcf00.png";